import React, { useState } from 'react';
import { NavLink as RRNavLink } from 'react-router-dom';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  // Dropdown,
  // NavbarText
} from 'reactstrap';

const Header = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div>
      <Navbar style={{ backgroundColor: '#7952b3', "margin-bottom": "3em" }} dark expand="md">
        <NavbarBrand tag={RRNavLink} exact to="/">Anthrax in Gannan</NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
            {/* <NavItem>
              <NavLink tag={RRNavLink} exact to="/">Home</NavLink>
            </NavItem> */}
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Data Overview
              </DropdownToggle>
              <DropdownMenu left>
                <DropdownItem tag={RRNavLink} to="/overview/summary">
                  Data Statistics
                </DropdownItem>
                <DropdownItem tag={RRNavLink} to="/overview/SpatialDistribution">
                  Spatial Distribution
                </DropdownItem>
                <DropdownItem tag={RRNavLink} to="/overview/TimeDistribution">
                  Time Distribution
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Time Series Analysis
              </DropdownToggle>
              <DropdownMenu left>
                <DropdownItem tag={RRNavLink} to="/ts/decomposition">
                  Time Series Decomposition
                </DropdownItem>
                <DropdownItem tag={RRNavLink} to="/ts/forecast">
                  Holt-Winters Forecast
                </DropdownItem>
                <DropdownItem tag={RRNavLink} to="/ts/granger">
                  Granger Casuality Test
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Regression Analysis
              </DropdownToggle>
              <DropdownMenu left>
                <DropdownItem tag={RRNavLink} to="/regression/HI-calculator">
                  Heat Index Calculator
                </DropdownItem>
                <DropdownItem tag={RRNavLink} to="/regression/models">
                  Regression Models
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
}

export default Header;
